import PlotBarChart from "../../components/Common/Charts/PlotBarChart"
import React from 'react';
import { Card, Col } from 'reactstrap';

const WebinarAverageCharts = (props) => {
  // Unique colors for each chart
  const qualityScoreColor = ['#fcd3a4']; // A distinct blue
  const clarityScoreColor = ['#A2CCFA']; // Light salmon
  const coverageScoreColor = ['#a3eea3']; // Light green
  const engagementScoreColor = ['#FFA3A5']; // Gold
  const studentSentimentColor = ['#A9C6FE']; // Orchid
  const responseScoreColor = ['#7cb9b2']; // Slate blue
  const teacherTimeSpokenColor = ['#82a4b1']; // Indian red
  const fluencyScoreColor = ['#eed3d9']; // Light sea green
  const {
    averageOverallQualityData,
    averageClarityScoreData,
    averageWebinarCoverageData,
    averageEngagementScoreData,
    averageStudentSentimentData,
    averageResponseScoreData,
    averageTeacherTimeSpokenData,
    averageFluencyScoreData,
  } = props;

  return (
    <>
      {/* Existing Charts */}
      <Col md={6}>
        <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
          <PlotBarChart
            xAxisTitle="Week"
            title="Overall Webinar Quality score (%)"
            yAxisTitle="Avg Webinar Quality Score (%)"
            barColors={qualityScoreColor}
            options={averageOverallQualityData}
            suffix="%"
          />
        </Card>
      </Col>
      <Col md={6}>
        <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
          <PlotBarChart
            xAxisTitle="Week"
            title="Clarity Score (%)"
            yAxisTitle="Avg Clarity Score (%)"
            barColors={clarityScoreColor}
            options={averageClarityScoreData}
            suffix="%"
          />
        </Card>
      </Col>
      <Col md={6}>
        <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
          <PlotBarChart
            xAxisTitle="Week"
            title="Webinar Coverage Score (%)"
            yAxisTitle="Avg Webinar Score (%)"
            barColors={coverageScoreColor}
            options={averageWebinarCoverageData}
            suffix="%"
          />
        </Card>
      </Col>
      <Col md={6}>
        <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
          <PlotBarChart
            xAxisTitle="Week"
            title="Engagement Score (%)"
            yAxisTitle="Avg Engagement Score (%)"
            barColors={engagementScoreColor}
            options={averageEngagementScoreData}
            suffix="%"
          />
        </Card>
      </Col>
      <Col md={6}>
        <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
          <PlotBarChart
            xAxisTitle="Week"
            title="Student Sentiment (%)"
            yAxisTitle="Avg Student Sentiment (%)"
            barColors={studentSentimentColor}
            options={averageStudentSentimentData}
            suffix="%"
          />
        </Card>
      </Col>

      <Col md={6}>
        <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
          <PlotBarChart
            xAxisTitle="Week"
            title="Responsiveness Score (%)"
            yAxisTitle="Avg Response Score (%)"
            barColors={responseScoreColor}
            options={averageResponseScoreData}
            suffix="%"
          />
        </Card>
      </Col>

      <Col md={6}>
        <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
          <PlotBarChart
            xAxisTitle="Week"
            title="Time Spoken by Teacher (%)"
            yAxisTitle="Avg Time Spoken (%)"
            barColors={teacherTimeSpokenColor}
            options={averageTeacherTimeSpokenData}
            suffix="%"
          />
        </Card>
      </Col>
      <Col md={6}>
        <Card className="h-full border border-gray-200 rounded-lg shadow-sm">
          <PlotBarChart
            xAxisTitle="Week"
            title="Fluency Score (%)"
            yAxisTitle="Avg Fluency Score (%)"
            barColors={fluencyScoreColor}
            options={averageFluencyScoreData}
            suffix="%"
          />
        </Card>
      </Col>
    </>
  );
};

export default WebinarAverageCharts;
